import Coach from './Coach';

export default Coach;
